<template>
  <div class="map" ref="map">
    <my-head title="驾驶员位置"/>
    dwqqqqqqqqqqq
  </div>
</template>

<script>
import myHead from '@/components/header'
import api from "@/common/api"
export default {
  name: 'map',
  data () {
    return {
    }
  },
  components: {
    myHead
  },
  methods: {
  },
  mounted () {
    // 确定高度
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/trafficCar/trafficCarMap.vue